import type {
  Base64Response,
  DemoOverlay,
  IDemo,
  IPresentation,
  IVariable,
  PresentationTokenResponse,
} from '@carboncopyco/types';

type PresentationDataOptions = {
  analyticsSessionId: string;
  forClient?: string;
  variables?: IVariable[];
  customDomain?: {
    domain: string;
    presentationTokenResponse: Base64Response<PresentationTokenResponse>;
  };
};

export type PresentationData = {
  presentation?: IPresentation;
  demo: IDemo | DemoOverlay;
  options: PresentationDataOptions;
};

type PreparePresentationData = {
  presentations: IPresentation[];
  demosList: (IDemo | DemoOverlay)[];
  analyticsSessionId: string;
};

export const preparePresentationsData = ({
  presentations,
  demosList,
  analyticsSessionId,
}: PreparePresentationData) => {
  const presentationsData: PresentationData[] = [];

  presentations.forEach((presentation, index) => {
    const presentationDemo = demosList.find(
      (demo) => demo.id === presentation.demoId
    );
    if (!presentationDemo) {
      return;
    }
    presentationsData.push({
      presentation: {
        ...presentation,
        hidden: index !== 0,
      },
      demo: {
        ...presentationDemo,
        variables: presentation?.variables,
      },
      options: {
        analyticsSessionId,
        forClient: presentation.forClient,
      },
    });
  });
  return presentationsData;
};
